import { render, staticRenderFns } from "./SettingsWidth.vue?vue&type=template&id=33097efc&"
import script from "./SettingsWidth.vue?vue&type=script&lang=js&"
export * from "./SettingsWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports